import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export const ScottBlairPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 pb-20 bg-navy-900 min-h-screen" data-id="element-302">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-303">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.5
      }} className="mb-8" data-id="element-304">
          <Link to="/" className="inline-flex items-center text-ice-500 hover:text-ice-400 font-semibold transition-colors group" data-id="element-305">
            <ArrowLeft className="w-5 h-5 mr-2 transform group-hover:-translate-x-1 transition-transform" data-id="element-306" />
            Back to Home
          </Link>
        </motion.div>

        <div className="bg-navy-800 border border-navy-700 rounded-sm overflow-hidden shadow-2xl" data-id="element-307">
          {/* Hero Section */}
          <div className="relative h-64 sm:h-80 md:h-96 bg-navy-700" data-id="element-308">
            <img src="https://cdn.magicpatterns.com/uploads/vcv3A1bUgZrtybtvAE23Cw/5746.png" alt="Scott Blair in action" className="w-full h-full object-cover object-center opacity-40" data-id="element-309" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-800 via-navy-800/60 to-transparent" data-id="element-310"></div>

            <div className="absolute bottom-0 left-0 w-full p-8 md:p-12 flex flex-col md:flex-row items-end gap-6 md:gap-8" data-id="element-311">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="w-32 h-36 md:w-40 md:h-48 shrink-0 rounded-sm overflow-hidden border-4 border-navy-800 shadow-xl bg-navy-700" data-id="element-312">
                <img src="https://cdn.magicpatterns.com/uploads/f6VUSkdgXoyVX3aUmVpiam/5753.png" alt="Scott Blair" className="w-full h-full object-cover object-center" data-id="element-313" />
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} className="mb-2 md:mb-6" data-id="element-314">
                <h1 className="text-4xl md:text-5xl font-black text-white tracking-tight mb-2" data-id="element-315">
                  Scott Blair
                </h1>
                <p className="text-ice-500 font-bold text-lg uppercase tracking-widest" data-id="element-316">
                  VP of Operations
                </p>
              </motion.div>
            </div>
          </div>

          {/* Content Section */}
          <div className="p-8 md:p-12" data-id="element-317">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="prose prose-lg prose-invert max-w-none" data-id="element-318">
              <div className="space-y-6 text-slate-300 leading-relaxed text-lg" data-id="element-319">
                <p data-id="element-320">
                  Scott Blair was a 3 time USA Hockey National Champion and OHL
                  Champion. He played professional hockey in the Chicago
                  Blackhawks system and also played some years in Europe.
                </p>
                <p data-id="element-321">
                  He currently plays overseas and works on and off ice with
                  players in a developmental role during the offseason in Tampa,
                  FL.
                </p>
              </div>

              {/* Quote */}
              <blockquote className="mt-12 p-8 bg-navy-900/50 border-l-4 border-ice-500 rounded-r-sm" data-id="element-322">
                <p className="text-xl italic text-slate-300 font-medium m-0" data-id="element-323">
                  "Success isn't just about talent. It's about having the right
                  plan, the right network, and the resilience to execute."
                </p>
              </blockquote>
            </motion.div>
          </div>
        </div>
      </div>
    </div>;
};